module.exports = fox => {
    require('common-stuffs/localStorageService')(fox);
}


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common/liveshow/dependencies/index.es.js